import { NgClass } from "@angular/common";
import {
  Component,
  computed,
  inject,
  input,
  ChangeDetectionStrategy,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { ActivatedRoute, Router } from "@angular/router";
import { IconComponent } from "@claas/claas-ui-components";
import { TranslatePipe } from "@ngx-translate/core";
import { map } from "rxjs";
import { ConfigService } from "../../../shared/config/config.service";
import { AuthImagePipe } from "../../../shared/pipes/auth-image.pipe";
import { ProductFamilyFavoritesService } from "../../../shared/services/product-family-favorites.service";

@Component({
  selector: "claas-product-card",
  imports: [AuthImagePipe, IconComponent, NgClass, TranslatePipe],
  templateUrl: "./product-card.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./product-card.scss",
})
export class ProductCard {
  config = inject(ConfigService);
  route = inject(ActivatedRoute);

  countryID = toSignal(
    this.route.paramMap.pipe(
      map((params) =>
        params.get("country")?.toLowerCase()
          ? encodeURIComponent(params.get("country")?.toLowerCase() as string)
          : "",
      ),
    ),
    {
      initialValue: "",
    },
  );
  languageID = toSignal(
    this.route.paramMap.pipe(
      map((params) =>
        params.get("language")
          ? encodeURIComponent(params.get("language")?.toLowerCase() as string)
          : "",
      ),
    ),
    {
      initialValue: "",
    },
  );
  year = toSignal(
    this.route.paramMap.pipe(
      map((params) =>
        params.get("year")
          ? encodeURIComponent(params.get("year")?.toLowerCase() as string)
          : "",
      ),
    ),
    {
      initialValue: "",
    },
  );

  id = input.required<string>();

  title = input.required<string>();

  text = input("");

  imgUrl = input.required<string>();

  router = inject(Router);

  private productFamilyFavoritesService = inject(ProductFamilyFavoritesService);
  productFamilyIdsIncluded = toSignal(
    this.productFamilyFavoritesService.includedIds$,
  );

  favoriteActive = computed(() => {
    return this.productFamilyIdsIncluded()?.includes(this.id());
  });

  handleFavorites(id: string) {
    if (!this.productFamilyIdsIncluded()?.includes(id)) {
      this.productFamilyFavoritesService.add(id);
    } else {
      this.productFamilyFavoritesService.remove(id);
    }
  }

  navigateTo(event: Event) {
    event.preventDefault();
    if (
      (event.target as HTMLElement) === event.currentTarget ||
      ((event.target as HTMLElement)?.closest("a") === event.currentTarget &&
        !(event.target as HTMLElement)?.closest("button"))
    ) {
      this.router.navigateByUrl(
        `/pia/${this.countryID()}/${this.languageID()}/${this.year()}/product/${encodeURIComponent(this.id())}`,
      );
    }
  }
}
